<template>

  <div class="row p-0 m-0" v-if="switch_years != 'off'">
    <div class="col m-0 ml-2 p-0 form-inline switch-years">
      <div>
        <span>{{ new Date().getFullYear() }}</span>
      </div>
      <div class="form-check form-switch form-inline">
        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
          @change="switchYearToggle" :checked="displayYear > new Date().getFullYear()">
        <label class="form-check-label" for="flexSwitchCheckDefault">{{ new Date().getFullYear() + 1 }}</label>
      </div>
    </div>
  </div>

  <div class="row p-0 m-0" v-if="paging != 'off'">
    <div class="col m-0 p-0">
      <button class="btn btn-sm btn-primary me-1" @click="subYear">&lt;&lt;</button>
      <button class="btn btn-sm btn-primary" @click="subMonth">&lt;</button>
    </div>

    <div class="col text-center">
      <h4>{{ $trans.get('__JSON__.Year') }}: {{ displayYear }}</h4>
    </div>

    <div class="col text-end m-0 p-0">
      <button class="btn btn-sm btn-primary me-1" @click="addMonth">&gt;</button>
      <button class="btn btn-sm btn-primary" @click="addYear">&gt;&gt;</button>
    </div>
  </div>

  <div v-if="employee" class="row p-0 m-0">
    <div class="col m-1 p-0 month" v-for="(month, index) in months">
      <div class="col monthhead rounded mb-1">
        {{ $trans.get('__JSON__.' + monthnames[month - 1]) }}
        <a v-if="links" :href="journalMonthLink(index)"><span class="material-symbols-outlined text-white"> visibility
          </span></a>
      </div>
      <div class="col border-bottom border-grey calendarday rounded small ps-0 pe-1" @click="daySelect(day)"
        v-for="day in monthDays[index]" :class="['day-' + day.getDay(), dayClass(day),
        { 'today': today(day) }]" :style="absenceColor(day)">
        <employee-calendar-day :day="day" :absence="absence(day)" :journalLink="journalWeekLink(day)"
          :worked="worked(day)" :hours="workhours(day)" :links="links" :team_id="employee.team_id"
          :hasTeamEvents="hasTeamEvents(day)" :teamEventsNames="teamEventsNames(day)" :user="user"
          :employee="employee" />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col employee-calendar-legend">
      <span class="material-symbols-outlined"> beach_access </span> {{ $trans.get("__JSON__.Vacation") }} -
      <span class="material-symbols-outlined"> schedule </span> {{ $trans.get("__JSON__.From flextime") }} -
      <span class="material-symbols-outlined"> money_off </span> {{ $trans.get("__JSON__.Unpaid") }} -
      <span class="material-symbols-outlined"> hourglass </span> {{ $trans.get("__JSON__.Requested") }} -
      <span class="material-symbols-outlined"> event </span> {{ $trans.get("__JSON__.Holiday") }} -
      <span class="material-symbols-outlined"> sick </span> {{ $trans.get("__JSON__.Sick") }} -
      <span class="material-symbols-outlined"> coronavirus </span> {{ $trans.get("__JSON__.Sick without certificate") }}
      -
      <span class="material-symbols-outlined"> star_rate </span> {{ $trans.get("__JSON__.Special leave") }}
      <span class="material-symbols-outlined"> autopause </span> {{ $trans.get("__JSON__.elsewise open / unclear") }}
    </div>
  </div>  
</template>

<script>
import axios from "axios";
import { resolveTransitionHooks } from "vue";
import { DateTime } from "luxon";

export default {
  name: "EmployeeCalendar",
  created() {
    this.startMonth = parseInt(this.start_month);
    this.startYear = parseInt(this.start_year);
    if (this.journallink != 'off') {
      this.links = true;
    }
  },
  props: {
    employee_id: null,
    start_month: null,
    start_year: null,
    journallink: String,
    paging: String,
    switch_years: String,
    // key: String,
    user: null,
    compact: Number
  },
  data() {
    return {
      daynames: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ],
      monthnames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      months: [],
      startMonth: null,
      startYear: null,
      displayYear: "",
      monthDays: [],
      absences: [],
      absenceDays: [],
      workDays: [],
      worktimeModel: null,
      holidays: [],
      links: false,
      employee: null,
      switchYear: null,
      teamevents: null,
    };
  },
  emits: ['daySelection'],
  computed: {
    startAt() {
      return new Date(this.startYear, this.startMonth - 1, 1).toISOString().split("T")[0];
    },
    endAt() {
      return new Date(this.startYear + 1, this.startMonth, 1).toISOString().split("T")[0];
    },
  },
  watch: {
  },
  mounted() {
    this.initComponent();
    this.fetchTeamEvents(this.startYear);
  },
  methods: {
    journalMonthLink(index) {
      var link = "/employees/" + this.employee_id + "/journal";
      if (this.compact == 1) {
        link += "_compact?year=" + this.startYear;
        link += "&month=" + (index+1);
        return link;
      }
      const startDate = this.monthDays[index][0];
      const endDate = this.monthDays[index][this.monthDays[index].length - 1];
      link += this.getDateLink(startDate, endDate);
      return link;
    },
    journalWeekLink(date) {
      var link = "/employees/" + this.employee_id + "/journal";
      const startDate = new Date(date.valueOf());
      startDate.setDate(startDate.getDate() - 6);

      link += this.getDateLink(startDate, date);
      return link;
    },
    today(date) {
      const today = new Date();
      return date.getFullYear() == today.getFullYear() && date.getMonth() == today.getMonth() && date.getDate() == today.getDate();
    },
    getDateLink(startDate, endDate) {
      var link =
        "?startdate=" +
        startDate.getFullYear() +
        "-" +
        (startDate.getMonth() + 1) +
        "-" +
        startDate.getDate();
      link +=
        "&enddate=" +
        endDate.getFullYear() +
        "-" +
        (endDate.getMonth() + 1) +
        "-" +
        endDate.getDate();
      return link;
    },
    initComponent() {
      this.monthDays = [];
      this.months = [];

      for (var i = 0; i < 12; i++) {
        var days = [];

        if (i + this.startMonth < 13) {
          this.months.push(i + this.startMonth);
          const monthDays = this.daysInMonth(i + this.startMonth, this.startYear);
          for (var d = 1; d <= monthDays; d++) {
            const newDay = new Date(this.startYear, i + this.startMonth - 1, d);
            days.push(newDay);
          }
        } else {
          this.months.push(i + this.startMonth - 12);
          const monthDays = this.daysInMonth(
            i + this.startMonth - 12,
            this.startYear + 1
          );
          for (var d = 1; d <= monthDays; d++) {
            days.push(new Date(this.startYear + 1, i + this.startMonth - 12 - 1, d));
          }
        }
        this.monthDays.push(days);
      }

      if (this.startMonth == 1) {
        this.displayYear = this.startYear;
      } else {
        this.displayYear = this.startYear + " / " + (this.startYear + 1);
      }
      this.fetchData();
    },
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
    to_luxon_ISOdate_fromJSDate(date) {
      var formattedDate = DateTime.fromJSDate(date).toISODate();
      return formattedDate;
    },
    dayClass(date) {
      var dayclass = [];
      if (date.getDay() < 1 || date.getDay() > 5) {
        dayclass.push('weekend');
      }

      var result = this.holidays.filter(this.filterDate(date, "day"));
      if (result.length > 0) {
        dayclass.push('holiday');
      }

      result = this.absenceDays.filter(this.filterDate(date, "intime"));
      if (result.length > 0) {
        dayclass.push(result[0].project.name.substring(0, 7));
      }

      result = this.absences.filter(this.filterDates(date, "start_at", "end_at"));
      if (result.length > 0) {

        var name = result[0].type.name;

        if (name == 'vacation' && result[0].from_flextime) {
          name = 'flextime';
        }

        if (result[0].absence_type_id == 2) {
          if (result[0].granted == 1) {
            name += 'granted';
          } else {
            name += 'requested';
          }
        }

        if (result[1]) {
          if (result[0].half_day && result[0].second_half && result[1].half_day && !result[1].second_half
            || result[0].half_day && !result[0].second_half && result[1].half_day && result[1].second_half) {
              // name = 'half' + name + '-both';
              // name = 'holiday';
            }
        }
        else {
          if (result[0].half_day && result[0].second_half) {
            name = 'half' + name + '-secondhalf';
          }

          if (result[0].half_day && !result[0].second_half) {
            name = 'half' + name + '-firsthalf';
          }
        }

        if (result[0].sick_certificate == 0 && result[0].absence_type_id == 1) {
          name = 'sick_without ' + name;
        }
        dayclass.push(name);
      }

      if (dayclass.length > 0) {
        return dayclass;
      }

      return null;
    },
    absence(date) {
      var absence = this.formatAbsence(null, null);

      var absencereasons = [];

      // Ist es ein Wochenende?
      if (date.getDay() < 1 || date.getDay() > 5) {
        absence.weekend = true;
        // absencereasons.push('weekend');
      }

      // Ist es ein Feiertag?
      result = this.holidays.filter(this.filterDate(date, "day"));
      if (result.length > 0) {
        absence.holiday = true;
        absence.half_holiday = result[0].half_day;
        absence.name = result[0].name;
        absencereasons.push(result[0].name);
      }

      // Gibt es eine Abwesenheit?
      result = this.absences.filter(this.filterDates(date, "start_at", "end_at"));
      
      if (result.length > 0) {
        var name = result[0].project.name;
        absence = this.formatAbsence(absence, result[0]);
        if (result.length > 1) {
          absence.next_absence = this.formatAbsence(null, result[1]);
          console.log('Next', absence.next_absence);
        }
        absencereasons.push(absence.name);
      }

      var result = this.absenceDays.filter(this.filterDate(date, "intime"));
      if (result.length > 0) {
        absence.name = result[0].project.name;
        absence.vacation = result[0].project.absence_type_id == 2;
        absence.half_day = result[0].half_day;
        absence.granted = true;

        absencereasons.push(absence.name);
      }

      if (absencereasons.length > 0) {
        absence.name = absencereasons;
        return absence;
      }

      return null;
    },
    formatAbsence(oldAbsence, result) {
      var absence = {
        name: null,
        vacation: false,
        granted: false,
        half_day: false,
        from_flextime: false,
        unpaid: false,
        holiday: false,
        half_holiday: false,
        weekend: false,
        sick: false,
        sick_without: false,
        special_leave: false,
        id: null,
        employee_id: null,
        start_at: null,
        next_absence: null,
        has_open_revoke_request: false,
      };
      if (oldAbsence) {
        absence = oldAbsence;
      }

      if (result) {
        var name = result.project?.name;
        absence.granted = result.granted;
        absence.vacation = result.absence_type_id == 2;
        absence.half_day = result.half_day;
        absence.from_flextime = result.from_flextime;
        absence.unpaid = result.unpaid;
        if (absence.unpaid) {
          name += ' (' + this.$trans.get('__JSON__.unpaid') + ')';
        }
        absence.sick = result.absence_type_id == 1 && result.sick_certificate == 1;
        absence.sick_without = result.absence_type_id == 1 && result.sick_certificate == 0;
        absence.special_leave = result.special_leave;
        absence.id = result.id;
        absence.employee_id = result.employee_id;
        absence.start_at = this.to_luxon_ISOdate_fromJSDate(result.start_at);
        absence.has_open_revoke_request = result.hasOpenRevokeRequest; 

        if (result.absence_type_id == 2) {
          if (!result.granted) {
            name += ' ' + this.$trans.get('__JSON__.requested');
          }
        }

        absence.name = name;

      }
      return absence;
    },
    absenceColor(date) {
      var result = this.absences.filter(this.filterDates(date, "start_at", "end_at"));

      if (result.length > 0) {
        if (result[0].absence_type_id == 3 || result[0].absence_type_id == 7) {
          return { 'background-color': result[0].project.color };
        }
      }
      return null;
    },
    // TODO: Weniger filtern mehr sortieren und zusammenfassen
    filterDate(date, field) {
      return function filter(entity) {
        return (
          date.getYear() == entity[field].getYear() &&
          date.getMonth() == entity[field].getMonth() &&
          date.getDate() == entity[field].getDate()
        );
      };
    },
    filterDates(date, firstDate, secondDate) {
      return function filter(entity) {
        return (
          date >= entity[firstDate].setHours(0, 0, 0, 0) && date <= entity[secondDate]
        );
      };
    },
    worked(date) {
      var result = this.workDays.filter(this.filterDate(date, "day"));
      if (result.length > 0) {
        return true;
      }
      return false;
    },
    workhours(date) {
      if (this.employee) {
        if (this.employee.worktime) {
          return parseFloat(this.employee.worktime[this.daynames[date.getDay()]] ?? 0);
        }
      }
      return 0;
    },
    hasTeamEvents(day) {
      if (!this.teamevents) {
        return false;
      }

      const dayDate = DateTime.fromJSDate(day).toISODate();

      const dayDateTeamEvents = this.teamevents.filter(element => element.team_id == this.employee.team_id &&
        dayDate >= DateTime.fromISO(element.start_at).toISODate()
        && dayDate <= DateTime.fromISO(element.end_at).toISODate()
      );

      if (dayDateTeamEvents.length > 0) {
        return true;
      }
      return false;
    },
    teamEventsNames(day) {
      if (!this.teamevents) {
        return null;
      }
      const dayDate = DateTime.fromJSDate(day).toISODate();

      const dayDateTeamEvents = this.teamevents.filter(element => element.team_id == this.employee.team_id &&
        dayDate >= DateTime.fromISO(element.start_at).toISODate()
        && dayDate <= DateTime.fromISO(element.end_at).toISODate()
      );

      if (dayDateTeamEvents.length > 0) {
        let eventNames = [];
        dayDateTeamEvents.forEach((teamEvent) => eventNames.push(teamEvent.name));
        return eventNames.join('<br>');
      }
      let eventNames = null;
      return eventNames;
    },
    fetchTeamEvents() {
      const dayStartFrom = DateTime.fromFormat(this.startAt, 'yyyy-MM-dd').toISODate();
      axios
        .get("/api/teamevents", {
          params: {
            datefrom: dayStartFrom,
          },
        })
        .then((resp) => {
          this.teamevents = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fetchData() {
      axios
        .get("/api/employees/" + this.employee_id)
        .then((resp) => {
          this.employee = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });

      axios
        .get("/api/absences/employee", {
          params: {
            employee_id: this.employee_id,
            start_at: this.startAt,
            end_at: this.endAt,
          },
        })
        .then((resp) => {
          this.absences = resp.data;
          this.absences.forEach((absence) => {
            absence.start_at = new Date(absence.start_at);
            absence.end_at = new Date(absence.end_at);
          });
        })
        .catch((error) => {
          console.log(error);
        });

      /*      axios
              .get("/api/employees/" + this.employee_id + "/stamps", {
                params: {
                  employee_id: this.employee_id,
                  start_at: this.startAt,
                  end_at: this.endAt,
                  absences: 1,
                },
              })
              .then((resp) => {
                this.absenceDays = resp.data;
                this.absenceDays.forEach((absenceDay) => {
                  absenceDay.intime = new Date(absenceDay.intime);
                });
              })
              .catch((error) => {
                console.log(error);
              });*/

      axios
        .get("/api/employeedays", {
          params: {
            employee_id: this.employee_id,
            start_at: this.startAt,
            end_at: this.endAt,
          },
        })
        .then((resp) => {
          this.workDays = resp.data;
          this.workDays.forEach((workDay) => {
            workDay.day = new Date(workDay.day);
          });
        })
        .catch((error) => {
          console.log(error);
        });

      axios
        .get("/api/holidays", {
          params: {
            start_at: this.startAt,
            end_at: this.endAt,
          },
        })
        .then((resp) => {
          this.holidays = resp.data;
          this.holidays.forEach((holiday) => {
            holiday.day = new Date(holiday.day);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    subYear() {
      this.startYear--;
      this.initComponent();
    },
    addYear() {
      this.startYear++;
      this.initComponent();
    },
    subMonth() {
      this.startMonth--;
      if (this.startMonth == 0) {
        this.startMonth = 12;
        this.startYear--;
      }
      this.initComponent();
    },
    addMonth() {
      this.startMonth++;
      if (this.startMonth == 13) {
        this.startMonth = 1;
        this.startYear++;
      }
      this.initComponent();
    },
    daySelect(day) {
      this.$emit('daySelection', day);
    },
    switchYearToggle() {
      if (document.location.href.indexOf('home?showNextYear') > 0) {
        document.location.href = '/my/home'
      } else {
        document.location.href = '/my/home?showNextYear=true';
      }
    },
  },
};
</script>

<style></style>
